/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default () => ({
    total: null,
    postsDashboard: null,
    post: null,
    hasOperator: false,
    newPost: null,
    history: null,
    sending: false,
    postHistories: null,
    postsList: null,
    statuses: null,
    posts: null,
    myPosts: null,
    usersList: null,
    postsConfig: {
        include: 'form,status,company,createdBy,racis',
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        filters: {},
        per_page: 15
    },
    myPostsConfig: {
        include: 'answers',
        per_page: 10,
        filters: {}
    },
    postsFilters: null,
    isPostRaciLoaded: false
})
